import React from 'react';
import '../styles/LoadingIndicator.scss';

interface LoadingIndicatorProps {
  message?: string;
}

/**
 * A simple loading indicator component that shows a spinner and optional message
 */
const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingIndicator;
